import styled from "styled-components";
import {WalletDialogButton} from "@solana/wallet-adapter-material-ui";

export const ConnectButton = styled(WalletDialogButton)`
  background: #db4261;
  color: #fff;
  border-color: #fff;
  border-radius: 0 !important;
  box-shadow: 2px 3px 0 #201c37 !important;
`;